import React from 'react';
import Spinner from './spinner.js';
import CircleButton from './circle_button.js';
import play from '../assets/play.png';

const SongPlayer = ({ youtubeUrl, player, isPlaying, setPlaying }) => {

    const videoId = youtubeUrl.split('?v=')[1];

    const togglePlayPause = () => {
        if (player.getVideoUrl().indexOf(videoId) === -1) {
            player.loadVideoById(videoId);
        }
        if (isPlaying) {
            player.pauseVideo();
            setPlaying(false);
        } else {
            player.playVideo();
            setPlaying(true);
        }
    };

    if (!player) {
        return <Spinner />
    }

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginBottom: '20px'
        }}>
            <CircleButton
                size="75px"
                bgColor={"hsl(151,13%,50%)"}
                imageContent={play}
                onMouseUp={togglePlayPause} />
        </div>
    );
};

export default SongPlayer;
